var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PanelTemplate',{ref:"panel"},[_c('TabsTemplate',{ref:"tabs",attrs:{"tabs":_vm.autoPanelTabs},on:{"onCloseButtonClicked":function($event){return _vm.hide()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }